import { render, staticRenderFns } from "./Select-Invoice.vue?vue&type=template&id=68ecc0b5"
import script from "./Select-Invoice.vue?vue&type=script&lang=js"
export * from "./Select-Invoice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports